document.addEventListener('DOMContentLoaded', () => {
    if (Shopify?.customer && Shopify.customer.tags.includes('pro')) return;

    let priceContainer = document.querySelector('.price');
    let variantRadios = document.querySelector('variant-radios');

    if (!priceContainer || !variantRadios) return;

    const updatePriceClass = () => {
        const priceContainer = document.querySelector('.price');
        if (!priceContainer) return;

        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-at-price'));
        const price = parseFloat(priceContainer.getAttribute('data-price'));
        const salePriceElement = document.querySelector('.price-item--sale');
        const oldPriceElement = document.querySelector('.variant-item__old-price');
        const regularPriceElement = document.querySelector('.price-item--regular');
        const badgeClass = 'price__badge-sale';
        let badge = priceContainer.querySelector(`.${badgeClass}`);

        if (!isNaN(compareAtPrice) && !isNaN(price)) {
            if (compareAtPrice > price) {
                salePriceElement && (salePriceElement.textContent = `${price.toFixed(2)} €`);
                oldPriceElement && (oldPriceElement.textContent = `${compareAtPrice.toFixed(2)} €`);
                regularPriceElement && (regularPriceElement.textContent = '');

                priceContainer.classList.add('price--on-sale');

                let discountPercentage;
                if (window.DiscountCalculator) {
                    discountPercentage = window.DiscountCalculator.calculateDiscount(compareAtPrice * 100, price * 100);
                } else {
                    const rawDiscount = ((compareAtPrice - price) / compareAtPrice) * 100;
                    discountPercentage = (rawDiscount % 1) < 0.55 ? Math.floor(rawDiscount) : Math.ceil(rawDiscount);
                }

                if (!badge) {
                    badge = document.createElement('span');
                    badge.className = `badge ${badgeClass} color-accent-1`;
                    badge.setAttribute('data-discount-badge', 'true');
                    badge.setAttribute('data-custom', 'true');
                    const soldOutBadge = priceContainer.querySelector('.price__badge-sold-out');
                    soldOutBadge ? soldOutBadge.insertAdjacentElement('beforebegin', badge) : priceContainer.appendChild(badge);
                }
                badge.textContent = `-${discountPercentage}%`;
                badge.style.display = '';
            } else {
                regularPriceElement && (regularPriceElement.textContent = `${price.toFixed(2)} €`);
                salePriceElement && (salePriceElement.textContent = '');
                oldPriceElement && (oldPriceElement.textContent = '');
                badge && (badge.style.display = 'none');

                priceContainer.classList.remove('price--on-sale');
            }
        }
    };

    const getSelectedVariant = () => {
        const scriptTag = variantRadios.querySelector('script[type="application/json"]');
        if (!scriptTag) return;

        const variants = JSON.parse(scriptTag.textContent);
        const selectedOptions = [...variantRadios.querySelectorAll('input.inputVariants:checked')].map(input => input.value.trim());

        const selectedVariant = variants.find(variant => selectedOptions.every((opt, index) => variant[`option${index + 1}`] === opt));

        if (selectedVariant) {
            const price = selectedVariant.price / 100;
            const compareAt = selectedVariant.compare_at_price ? selectedVariant.compare_at_price / 100 : price;

            const priceContainer = document.querySelector('.price');
            if (!priceContainer) return;

            priceContainer.setAttribute('data-price', price);
            priceContainer.setAttribute('data-compare-at-price', compareAt);

            const badge = priceContainer.querySelector('[data-discount-badge="true"]');
            if (badge) {
                badge.setAttribute('data-compare-at-price', compareAt * 100);
                badge.setAttribute('data-sale-price', price * 100);
            }

            updatePriceClass();
        }
    };

    const observer = new MutationObserver(() => setTimeout(updatePriceClass, 50));

    if (priceContainer) {
        observer.observe(priceContainer, { childList: true, subtree: true });
    }

    const globalObserver = new MutationObserver(() => {
        priceContainer = document.querySelector('.price');
        variantRadios = document.querySelector('variant-radios');

        if (priceContainer && variantRadios) {
            globalObserver.disconnect();
            variantRadios.addEventListener('change', getSelectedVariant);
            observer.observe(priceContainer, { childList: true, subtree: true });
            getSelectedVariant();
        }
    });

    globalObserver.observe(document.body, { childList: true, subtree: true });
    variantRadios.addEventListener('change', getSelectedVariant);
    setTimeout(getSelectedVariant, 50);
});